import React from "react";
import Settings from "./views/SettingsPage";
import { SettingsContextProvider } from "./SettingsView";
import SettingsContent from "../../constants/contentFile.json";

const SettingsPage = () => {
  return (
    <SettingsContextProvider>
      <Settings textContent={SettingsContent.settings} />
    </SettingsContextProvider>
  );
};

export default SettingsPage;
